import { useViewModel } from '@descomplica/microfrontend-react';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import React from 'react';
import { useLocation } from 'react-router-dom';

import { MicrofrontendViewModel } from '../Microfrontend.vm';

const AnalyticsPageViewProvider = (): React.ReactElement | null => {
  const vm = useViewModel(MicrofrontendViewModel);
  const { pathname } = useLocation();

  useEffect(() => {
    vm.analyticsTrackPageView();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return <></>;
};

export default observer(AnalyticsPageViewProvider);
